/* eslint-disable quotes */
import { Color, ColorSchema, ColorStatus } from "themes/interfaces";

export default {
  primary: { color: "#1390D7", text: "#ffffff" } as ColorSchema,
  accent: { color: "#00519C", text: "#ffffff" } as ColorSchema,
  status: {
    success: { color: "#3abb70", text: "#ffffff" } as ColorSchema,
    error: { color: "#BB3A3A", text: "#ffffff" } as ColorSchema,
  } as ColorStatus,
  disabled: { color: "#b3b3b3", accent: "#959595" } as ColorSchema,
  black: "#000000",
  white: "#ffffff",
} as Color;
